import { useContext } from "react";

import { EditTaskContext } from "./EditTaskContext";

export function useEditTask() {
  const context = useContext(EditTaskContext);
  if (!context) {
    throw new Error("useEditTask must be used within a EditTaskProvider");
  }
  return context;
}
